import { styled } from '@mui/material';
import ContinueButton from './continue-button';

const PaypalButton = styled(ContinueButton)({
  backgroundColor: '#FFC43A',
  borderRadius: '.25rem',
  paddingTop: '.75rem',
  paddingBottom: '.75rem',
  height: 'inherit',
  color: '#253B80',
  alignItems: 'center',
  display: 'flex',
  gap: '0.5rem',
  '&:hover': {
    backgroundColor: '#FFC43A',
    color: '#253B80',
  },
  '&:not(:hover)': {
    backgroundColor: '#FFC43A',
    color: '#253B80',
  },
});

export default PaypalButton;
